export default __webpack_public_path__ + "8c6f2b89137a7dcdc643d90053ea33d2.svg";